import React from "react";
import { Typography, Empty, Button, Row } from "antd";
import { template, resolveUrl, formatTime } from "@reco-m/core";
import { Namespaces } from "@reco-w/office-models";
import { ImageAuto, ViewComponent } from "@reco-w/core-ui";
import { Swiper, SwiperSlide } from "swiper/react";
const { Paragraph } = Typography;
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs } from "swiper";
import { r2040ArticleService } from "./common/r2040article.service";
SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs]);

export namespace R2040ArticleList {
    export interface IProps extends ViewComponent.IProps {
        tagIds: any[]
        inTagIds: any[]
        isCase: boolean
        caseType: number
        pageSize: number
    }

    export interface IState extends ViewComponent.IState { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.office;

        componentDidMount() {
            this.dispatch("input", { newsSlides: 3, newsSpace: 0, caseSlides: 2, caseSpace: 40 });
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });

            const { tagIds = [], inTagIds = [], pageSize = 99999 } = this.props;
            r2040ArticleService.getPaged({ pageSize: pageSize, tagIds, inTagIds, isValid: true, orderBy: 'isTop,sequence,id desc' }).then(d => {
                this.dispatch({ type: 'input', data: { [`datas${tagIds.join('') || inTagIds.join('')}`]: d.items } })
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 1200) {
                this.dispatch("input", { newsSlides: 1, newsSpace: 0, caseSlides: 1, caseSpace: 0 });
            } else {
                this.dispatch("input", { newsSlides: 3, newsSpace: 60, caseSlides: 2, caseSpace: 40 });
            }
        }

        render(): React.ReactNode {
            const { tagIds = [], inTagIds = [] } = this.props;
            const { state, caseType } = this.props,
                newsSlides = state!.newsSlides,
                datas = state![`datas${tagIds.join('') || inTagIds.join('')}`] || [],
                caseSlides = state!.caseSlides,
                caseSpace = state!.caseSpace,
                newsSpace = state!.newsSpace;

            if (!datas?.length) {
                return <Empty />
            }

            const onClick = (item) => {
                console.log(item);

                if (item.contentType == 1) {
                    if (caseType) {
                        this.goTo(`/information/case/${item.id}/1`);
                    } else {
                        this.goTo(`/information/details/${item.id}`);
                    }
                } else if (item.contentType == 2) {
                    window.open(item.content)
                }
            }

            if (caseType === 1) {
                return <div className="case-box">
                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                    <Swiper
                        slidesPerView={caseSlides}
                        className="case-swiper"
                        style={{ height: 580 }}
                        pagination={true}
                        navigation={{
                            nextEl: '.case-box .swiper-button-next',
                            prevEl: '.case-box .swiper-button-prev'
                        }}
                        spaceBetween={caseSpace}
                    >
                        {datas.map((item, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <div className="case-swiper-item" style={{ cursor: 'pointer' }} onClick={onClick.bind(this, item)}>
                                        <div className="case-img">
                                            <ImageAuto.Component src={resolveUrl(item.logo)} width="100%" height="100%" radius={0} />
                                        </div>
                                        <div className="case-swiper-write">
                                            <Paragraph ellipsis={{ rows: 1, expandable: false }} className="mb0 size-24 primary-color">
                                                {item.title}
                                            </Paragraph>
                                            <Paragraph ellipsis className="mb0 size-18 gray-tow-color mt12">
                                                <i className="icon iconzuobiao mr5 gray-three-color" />{item.caseAddress}
                                            </Paragraph>
                                            <div className="mt20">
                                                {
                                                    (item.tags || '').split(',').map((tag, j) => {
                                                        return (
                                                            <Button type="primary" ghost key={j} className="mr10">{tag}</Button>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            }


            if (caseType === 2) {
                return <div className="case-box">
                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                    <Swiper
                        slidesPerView={caseSlides}
                        className="case-swiper type1"
                        style={{ height: 580 }}
                        pagination={true}
                        navigation={{
                            nextEl: '.case-box .swiper-button-next',
                            prevEl: '.case-box .swiper-button-prev'
                        }}
                        spaceBetween={caseSpace}
                    >
                        {datas.map((item, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <div className="case-swiper-item" onClick={onClick.bind(this, item)}>
                                        <div className="case-img">
                                            <ImageAuto.Component src={resolveUrl(item.logo)} width="100%" height="100%" radius={0} />
                                        </div>
                                        <div className="case-swiper-write">
                                            <Paragraph ellipsis={{ rows: 1, expandable: false }} className="mb0 size-24 primary-color">
                                                <i className="arrow-sj mr10" />{item.title}
                                            </Paragraph>
                                            <Paragraph ellipsis={{ rows: 3, expandable: false }} className="mb0 size-18 gray-tow-color mt12">
                                                {item.summary}
                                            </Paragraph>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            }

            if (caseType === 3) {
                return <div className="anli-swiper-box">
                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                    <Swiper
                        slidesPerView={1}
                        className="anli-swiper gray mt10"
                        style={{ height: 580 }}
                        pagination={false}
                        navigation={{
                            nextEl: '.anli-swiper-box .swiper-button-next',
                            prevEl: '.anli-swiper-box .swiper-button-prev'
                        }}
                        spaceBetween={10}
                    >
                        {datas.map((item, i) => <SwiperSlide key={i}>
                            <Row className="anli-swiper-item" onClick={onClick.bind(this, item)}>
                                <ImageAuto.Component src={resolveUrl(item.logo)} width="70%" height="490px" radius={0} />
                                <div className="anli-swiper-write">
                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="mb0 size-22 white-color mt30">
                                        {item.title}
                                    </Paragraph>
                                    <Paragraph ellipsis={{ rows: 4, expandable: false }} className="mb0 size-16 white6 mt40 anli-swiper-desc">
                                        {item.summary}
                                    </Paragraph>
                                    <div className="anli-swiper-date">
                                        {formatTime(item.publishTime, 'yyyy.MM.dd')}
                                    </div>
                                    <div className="swiper-number">{i < 9 ? `0${i + 1}` : i + 1}</div>
                                </div>
                            </Row>
                        </SwiperSlide>)}
                        {/* <SwiperSlide>
                            <Row className="anli-swiper-item">
                                <ImageAuto.Component src="assets/images/second/anli-img5.jpg" width="70%" height="490px" radius={0} />
                                <div className="anli-swiper-write">
                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="mb0 size-22 white-color mt30">
                                        数字经济（金融科技）产业发展成都推介会成功举办
                                    </Paragraph>
                                    <Paragraph ellipsis={{ rows: 4, expandable: false }} className="mb0 size-16 white6 mt40 anli-swiper-desc">
                                        瑞谷云企圆满举办招商数字经济（金融科技）
                                        产业发展成都推介会。西湖区副区长韩斌带队，
                                        西溪谷管委会、区投促局、区商务局（金融办）
                                        相关负责人参加。
                                    </Paragraph>
                                    <div className="anli-swiper-date">
                                        2022.10.16
                                    </div>
                                    <div className="swiper-number">02</div>
                                </div>
                            </Row>
                        </SwiperSlide> */}
                    </Swiper>
                </div>

            }
            if (caseType === 4)
                return <div className="case-box">
                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                    <Swiper
                        slidesPerView={caseSlides}
                        className="case-swiper type1"
                        style={{ height: 580 }}
                        pagination={true}
                        navigation={{
                            nextEl: '.case-box .swiper-button-next',
                            prevEl: '.case-box .swiper-button-prev'
                        }}
                        spaceBetween={caseSpace}
                    >
                        {datas.map((item, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <div className="case-swiper-item">
                                        <div className="case-img">
                                            <ImageAuto.Component src={resolveUrl(item.logo)} width="100%" height="100%" radius={0} />
                                        </div>
                                        <div className="case-swiper-write">
                                            <Paragraph ellipsis={{ rows: 1, expandable: false }} className="mb0 size-24 primary-color">
                                                <i className="arrow-sj mr10" />{item.title}
                                            </Paragraph>
                                            <Paragraph ellipsis={{ rows: 2, expandable: false }} className="mb0 size-18 gray-tow-color mt12">
                                                {item.summary}
                                            </Paragraph>
                                            <div className="case-swiper-date">
                                                {formatTime(item.publishTime, 'yyyy.MM.dd')}
                                                <i className="case-arrow" />
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>

            return <div className="news-swiper-box"> <Swiper
                slidesPerView={newsSlides}
                className="news-swiper mt10"
                style={{ height: 460 }}
                pagination={true}
                spaceBetween={newsSpace}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                }}
            >

                {(datas).map((item, i) => {
                    return (
                        <SwiperSlide key={i}>
                            <div className="news-swiper-item" style={{ cursor: 'pointer' }} onClick={onClick.bind(this, item)}>
                                <div className="news-img">
                                    <ImageAuto.Component src={resolveUrl(item.logo)} width="100%" height="100%" radius={0} />
                                </div>
                                <div className="pg20">
                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="mb0 size-18 gray-one-color">
                                        {item.title}
                                    </Paragraph>

                                    <Paragraph ellipsis className="mb0 size-14 gray-three-color mt12">
                                        {item.summary || ''}
                                    </Paragraph>
                                    {item.contentType !== 3 && <div className="mt20">
                                        <span className="list-arrow" />
                                    </div>}
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            </div>;
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.office]);
}
